import { render, staticRenderFns } from "./LayoutPrimary.vue?vue&type=template&id=64a88bc3&scoped=true&"
import script from "./LayoutPrimary.vue?vue&type=script&lang=js&"
export * from "./LayoutPrimary.vue?vue&type=script&lang=js&"
import style0 from "./LayoutPrimary.vue?vue&type=style&index=0&id=64a88bc3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a88bc3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\agent\\_work\\11\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64a88bc3')) {
      api.createRecord('64a88bc3', component.options)
    } else {
      api.reload('64a88bc3', component.options)
    }
    module.hot.accept("./LayoutPrimary.vue?vue&type=template&id=64a88bc3&scoped=true&", function () {
      api.rerender('64a88bc3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/LayoutPrimary.vue"
export default component.exports